import { Card, CardContent, Grid, Skeleton, Toolbar, CardActions, Button } from '@mui/material'
import Header from 'components/Header'
import { useTranslation } from 'react-i18next'

export default function DocumentFormSkeleton() {
  const { t } = useTranslation()
  return (
    <Card component="form" noValidate sx={{ minHeight: '100%' }}>
      <Toolbar />
      <Header title={t("Document")} close small />
      <CardContent>
        <Grid container spacing={2}>
          <Grid item sm={12} xs={12}>
            <Skeleton variant="rounded" height={35} />
          </Grid>
          <Grid item sm={12} xs={12}>
            <Skeleton variant="rounded" height={35} />
          </Grid>
          <Grid item sm={12} xs={12}>
            <Skeleton variant="rounded"  width={150} height={35} />
          </Grid>
          <Grid item sm={12} xs={12}>
            <Skeleton variant="rounded" height={35} />
          </Grid>
          <Grid item sm={12} xs={12}>
            <Skeleton variant="rounded"  width={150} height={35} />
          </Grid>
        </Grid>
      </CardContent>
      <CardActions sx={{ justifyContent: 'flex-end' }}>
        <Button variant="outlined">
          {' '}
          <Skeleton />
        </Button>
        <Button type="submit" variant="contained">
          <Skeleton />
        </Button>
      </CardActions>
    </Card>
  )
}
